export default class PricingService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getUnitPrices(args) {
    return this.axiosIns.get(this.serviceConfig.pricing, { params: args });
  }

  deleteUnitPrice(importId) {
    return this.axiosIns.delete(`${this.serviceConfig.pricing}/${importId}`);
  }

  getUnitPriceDetail(importId) {
    return this.axiosIns.get(`${this.serviceConfig.providerPriceTable}/${importId}`);
  }

  getAllAdditionalFees(args) {
    return this.axiosIns.get(`${this.serviceConfig.providers}/additional-fees/all`, {
      params: args
    });
  }

  createPricing(importId) {
    return this.axiosIns.post(`${this.serviceConfig.providerPrices}/import/${importId}/confirm`);
  }

  getProviderRules(args) {
    return this.axiosIns.get(`${this.serviceConfig.providers}/rule-fees/all`, { params: args });
  }

  getProviderRuleDetail(providerId, ruleId) {
    return this.axiosIns.get(`${this.serviceConfig.providers}/${providerId}/rule-fees/${ruleId}`);
  }

  createProviderRule({ providerId, ...args }) {
    return this.axiosIns.post(`${this.serviceConfig.providers}/${providerId}/rule-fees`, args);
  }

  updateProviderRule({ providerId, ruleId, ...args }) {
    return this.axiosIns.put(
      `${this.serviceConfig.providers}/${providerId}/rule-fees/${ruleId}`,
      args
    );
  }

  deleteProviderRule(providerId, feeId) {
    return this.axiosIns.delete(`${this.serviceConfig.providers}/${providerId}/rule-fees/${feeId}`);
  }

  getSaleUnitPrices(args) {
    return this.axiosIns.get(`${this.serviceConfig.customerRegionPrices}/all`, { params: args });
  }

  deleteSaleUnitPrice(importId) {
    return this.axiosIns.delete(`${this.serviceConfig.customerRegionPrices}/${importId}`);
  }

  getSaleUnitPriceDetail(importId) {
    return this.axiosIns.get(`${this.serviceConfig.customerRegionPricesTable}/${importId}`);
  }

  createSaleUnitPrice(importId) {
    return this.axiosIns.post(
      `${this.serviceConfig.customerRegionPrices}/import/${importId}/confirm`
    );
  }

  previewSaleUnitPrice({
    customerId,
    file,
    packageType,
    packageTypeValue,
    transportType,
    transportDirection,
    activeAt,
    activeUntil,
    providerId
  }) {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('packageType', packageType);
    formData.append('packageTypeValue', packageTypeValue);
    formData.append('transportType', transportType);
    formData.append('transportDirection', transportDirection);
    formData.append('activeAt', activeAt);
    formData.append('activeUntil', activeUntil);
    formData.append('customerId', customerId);
    formData.append('providerId', providerId);

    return this.axiosIns.post(`${this.serviceConfig.customerRegionPrices}/import`, formData);
  }

  getSalePricesAdditionalFees({ customerId, providerId, ...args }) {
    return this.axiosIns.get(
      `${this.serviceConfig.customers}/${customerId}/additional-fees/${providerId}`,
      {
        params: args
      }
    );
  }

  saveSalePricesAdditionalFees({ customerId, providerId, ...args }) {
    return this.axiosIns.put(
      `${this.serviceConfig.customers}/${customerId}/additional-fees/${providerId}`,
      args
    );
  }

  getAllSalePricesAdditionalFees(args) {
    return this.axiosIns.get(`${this.serviceConfig.customers}/additional-fees/all`, {
      params: args
    });
  }

  getAllSalePricesRules(args) {
    return this.axiosIns.get(`${this.serviceConfig.customers}/rule-fees/all`, { params: args });
  }

  getSalePricesRules({ customerId, providerId, ...args }) {
    return this.axiosIns.get(
      `${this.serviceConfig.customers}/${customerId}/rule-fees/${providerId}`,
      {
        params: args
      }
    );
  }

  saveSalePricesRules({ customerId, providerId, ...args }) {
    return this.axiosIns.put(
      `${this.serviceConfig.customers}/${customerId}/rule-fees/${providerId}`,
      args
    );
  }
}
